import { Injectable, inject } from '@angular/core';

import type { Observable } from 'rxjs';

import { HttpApiService } from '@core/http-legacy';

import type {
  RequisitionFormDeleteParam,
  RequisitionsFormFetchResponse,
  RequisitionsFormUpdateBody,
} from './form.types';

@Injectable({ providedIn: 'root' })
export class RequisitionsFormHttpClient {
  protected readonly httpApi = inject(HttpApiService);

  public fetch(): Observable<RequisitionsFormFetchResponse> {
    return this.httpApi.get('/requisitions/settings/form');
  }

  public update(body: RequisitionsFormUpdateBody): Observable<RequisitionsFormFetchResponse> {
    return this.httpApi.patch('/requisitions/settings/form', {}, body);
  }

  public delete(param: RequisitionFormDeleteParam): Observable<RequisitionsFormFetchResponse> {
    return this.httpApi.delete(`/requisitions/settings/form/${param}`);
  }

  public deleteCustomField(id: number): Observable<RequisitionsFormFetchResponse> {
    return this.httpApi.delete(`/requisitions/settings/form/dynamic_fields/${id}`);
  }
}
